import React from 'react';
import { Typography, Grid, Paper, Box } from '@mui/material';
import ButtonWithCheckbox from './components/buttonWithCheckbox';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function PatientHistorySheet() {
  const navigate = useNavigate();
  const patientData = useSelector((state) => state.clinicalReducer);
  const intermediateData = patientData.selectedPatientData.patient;

  const buttonHandler = (activeTab) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(
      `/patient/${patientData.selectedPatientData.patient.id}/clinical-management?tab=${activeTab}`,
    );

  };

  return (
    <Paper sx={{ padding: 3, marginBottom: 3, boxShadow: 3, borderRadius: 2 }}>
      <Grid container spacing={2}>
        {/* Heading */}
        <Grid item xs={12}>
          <Typography variant="h5" align="center" gutterBottom>
            Patient History Sheet
          </Typography>
        </Grid>
        <Box flex="1 1 100%" sm="1 1 66%">
          <Typography variant="body1" gutterBottom>
            <strong>Name:</strong> {intermediateData.firstName}{' '}
            {intermediateData.lastName}
            {/* {selectedPatientData.patient.partner.firstName}{' '}
                {selectedPatientData.patient.partner.lastName} */}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Phone:</strong> {intermediateData.phone}
            {/* {selectedPatientData.patient.partner.phone} */}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>MPID:</strong> {intermediateData.upid}
            {/* {selectedPatientData.patient.upid} */}
          </Typography>
        </Box>

        {/* Row of buttons with checkboxes */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="center">
            {/* 4 Buttons aligned in a single row */}
            <Grid item>
              <ButtonWithCheckbox
                displayKey={'Basic Details'}
                checked={intermediateData.id ? true : false}
                lastUpdated={patientData.infertilityDetails.updatedAt}
                by={intermediateData.referral.referringPhysician}
                onClickHandler={() => buttonHandler(1)}
                showCaption={
                  intermediateData.referral.referringPhysician &&
                  intermediateData.updatedAt
                    ? true
                    : false
                }
              />
            </Grid>
            <Grid item>
              <ButtonWithCheckbox
                displayKey={'Patient History'}
                checked={intermediateData.histories.id ? true : false}
                lastUpdated={intermediateData.histories.updatedAt}
                by={intermediateData.referral.referringPhysician}
                onClickHandler={() => buttonHandler(2)}
                showCaption={
                  intermediateData.referral.referringPhysician &&
                  intermediateData.histories.updatedAt
                    ? true
                    : false
                }
              />
            </Grid>
            <Grid item>
              <ButtonWithCheckbox
                displayKey={'Examination and Evaluation'}
                checked={intermediateData.examinations.id ? true : false}
                lastUpdated={intermediateData.examinations.updatedAt}
                by={intermediateData.referral.referringPhysician}
                onClickHandler={() => buttonHandler(3)}
                showCaption={
                  intermediateData.referral.referringPhysician &&
                  intermediateData.examinations.updatedAt
                    ? true
                    : false
                }
              />
            </Grid>
            <Grid item>
              <ButtonWithCheckbox
                displayKey={'Treatment Plan'}
                checked={intermediateData.treatmentPlans.id ? true : false}
                lastUpdated={intermediateData.treatmentPlans.updatedAt}
                by={intermediateData.referral.referringPhysician}
                onClickHandler={() => buttonHandler(4)}
                showCaption={
                  intermediateData.referral.referringPhysician &&
                  intermediateData.treatmentPlans.updatedAt
                    ? true
                    : false
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
